// extracted by mini-css-extract-plugin
export var lab = "menu-module--lab--0f4a2";
export var li = "menu-module--li--9e03b";
export var link = "menu-module--link--03293";
export var menu = "menu-module--menu--ee8e1";